module.exports = __webpack_public_path__ + "076e33a87687608d16ee06e5d52a7573.png";